export enum CounterActionTypes {
  POLLING = '@counter/fetch',
  POLLING_STARTED = '@counter/fetch/started',
  POLLING_SUCCEED = '@counter/fetch/succeed',
  POLLING_FAILED = '@counter/fetch/failed',
  POLLING_CANCELLED = '@counter/fetch/cancelled',
}
